import { render, staticRenderFns } from "./app.vue?vue&type=template&id=358115e6&"
import script from "./../ts/app.ts?vue&type=script&lang=js&"
export * from "./../ts/app.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports